import React, {useState} from 'react';
import { Redirect } from 'react-router-dom';
import {
    TextInput,
    DateInput,
    FormDataConsumer,
    required,
    CardActions,
    ListButton,
    Toolbar,
    SaveButton,
    Edit,
    SimpleForm
} from 'react-admin';

import withStyles from '@material-ui/core/styles/withStyles';
import EditDetails from './EditDetails'
import HtmlToReact from 'html-to-react'
var HtmlToReactParser = HtmlToReact.Parser;
var htmlToReactParser = new HtmlToReactParser();

let uid = null;

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const CheckListEditActions =(basePath) => (
    <CardActions style={cardActionStyle}>
        <ListButton basePath={'/checklist?filter=%7B"uid"%3A"' + uid +'"%7D&order=DESC&page=1&perPage=25&sort=id'}  label='List'/>
    </CardActions>
);


const editStyles = {
    root: { alignItems: 'flex-start'},
    trainer_init: {  width: '2em' },
    trainee_init: {  width: '2em' },
    booth: {  width: '2em' },
    date: {  
        width: '1em',
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
    date_prof: {  width: '7em' },

    inlineBlock: {
        display: 'inline',
        margin: '2px',
        padding: '2px',
    },
};


const getTable=(_rows, _fields)=>{
    var nums = []
    for(var i=0; i < _rows; i++){nums.push(i)}

    return (
    <>
    {
       nums.map((nitem, i)=>(
        <tr key={i}>
            {
            _fields && _fields.map((item, index)=>(
                <td>
                    <TextInput source={item + i + '_'+ index} fullWidth label="" />
                </td>
                    )
            )
            }
        </tr>
       )
    )}
    </>
    )
}

const Forms =({data})=>{
    var forms = [];
    if(data){
        try{
            forms = JSON.parse(data);
        } catch(e){
            forms = data;
        }
    }
   
    var tot_size = 0;
    forms && forms.map((fitem)=>(
        fitem['form_fields'].map((item)=>(tot_size+= item['field_size'])
            )
        ) 
    )

    var factor = 100/ tot_size
    
    return(
        <>
        {
            forms && forms.map((fitem, findex)=>(
                <>
                <p></p>
                <p style={{textAlign:'center', fontWeight:'bold'}}>{fitem['form_subheading']}</p>
                <table border="1" cellSpacing="0" style={{width: "100%", textAlign:"center"}}>
                <tbody>
                    <tr key={findex+50}>
                    {
                    fitem['form_fields'].map((item, index) =>(
                        <td style={{width: `${factor * (item['field_size']?item['field_size']: 50 )}%`}}><b>{htmlToReactParser.parse(item['field_name'])}</b></td>
                        )
                    )}
                    </tr>  
                    {getTable(fitem['num_rows'], fitem['form_fields'])}
                </tbody>    
                </table>
                <p></p>
                <p></p>
                 </>
            )

        )}
        </>
    )
}


const GetForm=({data})=>{

   return (data && data.form_heading) ?
   <table style={{width: "100%"}}>  
   <tbody>
   <tr>
       <td  colSpan="4">&nbsp;</td></tr>
   <tr>
       <td colSpan="4"><hr /></td>
   </tr>
   <tr>
       <td  colSpan="4">&nbsp;</td>
   </tr>
       
   <tr>
       <td colSpan="4" style={{textAlign:"center"}}><h2 >TRAINING FORM</h2></td>
   </tr>
   <tr> 
       <td colSpan="4" style={{textAlign: "center"}}><Heading  data={data && data.form_heading} /></td>
   </tr>
   <tr>
       <td >Trainee Name:</td>
       <td colspan="2" ><TextInput source="trainee" label="" defaultValue={data && data.full_name} fullWidth/></td>
       <td  style={{cellSpacing:"10", alignSelf:"start" }}>&nbsp;</td>
   </tr>
   <tr>
       <td  colSpan="4">&nbsp;</td>
   </tr>
   <tr>
       <td  colSpan="4">&nbsp;</td>
   </tr>
   <tr>
       <td colSpan="4">
       <Forms data={data && data.forms} />
       </td>
   </tr>
   <tr><td  colSpan="4">&nbsp;</td></tr>
   <tr>
       <td>Trainee Signature:</td><td style={{width:"30%",cellSpacing:"10" }}><TextInput source="form_trainee_sign" label=""/></td>
       <td>&nbsp;Date:</td><td style={{width:"30%",cellSpacing:"10" }}><DateInput source='form_trainee_sign_date'    label="" locales="en-us"  locales="en-us"/></td>
   </tr>
   <tr>
       <td>Quality  Signature:</td><td style={{width:"30%", cellSpacing:"10" }}><TextInput source="form_qa_sign" label=""/></td>
       <td>&nbsp;Date:</td><td style={{width:"30%", cellSpacing:"10" }}><DateInput source='form_qa_sign_date'    label="" locales="en-us"  locales="en-us"/></td>
   </tr>
   <tr><td  colSpan="4">&nbsp;</td></tr>
   <tr>
       <td colSpan="3" style={{fontSize: "7"}}>{data && data.form_footer}</td>
       <td>&nbsp;</td>
   </tr>
   </tbody>

</table>: '';
}



const CheckListToolbar = props  => (
    <Toolbar {...props}>  
        <SaveButton
            label="save"    
            submitOnEnter={true}
            redirect={'/checklist?filter=%7B"id"%3A"' + uid +'"%7D&order=DESC&page=1&perPage=25&sort=id'}
        />
    </Toolbar>
);


const Heading=({data})=>{
    //console.log(data)
    return (<h3>{data}</h3>)
}

const GetKey=({ record }) => (
    uid = (record.uid)? record.uid:uid,
    (uid)? '': <Redirect to="/userslist" />
);

const CheckListEdit =({ classes, ...props }) => (
    
<Edit 
    title='Checklist | Edit' 
    {...props}  
    actions={<CheckListEditActions  />} 
    >
    <SimpleForm toolbar={<CheckListToolbar  />}>
    <GetKey props ={props}/>
        <table style={{width:"99%", fontSize: "12px"}}>
            <tbody>
            <tr>
                <td colSpan="4">
                    <table  border ="1" cellSpacing="0" style={{width:"100%", textAlign: "center"}}>
                    <tbody>
                    <tr>
                        <td>
                            <table  border ="0" style={{width:"100%", textAlign: "center"}}>
                            <tbody>
                            <tr>
                                <td style={{fontSize: "9px"}}> 
                                    Training and Education Procedures
                                </td>
                            </tr>
                            <tr>
                                <td >
                                    <FormDataConsumer>
                                    {
                                        ({ formData, ...rest }) => <Heading  data={formData.name}/>  
                                    }
                                    </FormDataConsumer>
                                </td>
                            </tr>
                            </tbody>
                            </table>
                        </td>                  
                    </tr>
                    </tbody>
                    </table>
                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td>Trainee Name:</td>
                <td classes={classes.cell30per}><TextInput source="trainee" label="" /></td>
                <td>&nbsp;Center:</td><td classes={classes.cell30per}><TextInput source="location"   label="" /></td>
            </tr>
            <tr>
                <td>Trainer Name:</td><td classes={classes.cell30per}><TextInput source="trainer1" label=""/></td>
                <td>&nbsp;Initial:</td><td classes={classes.cell30per}><TextInput source="trainer1_init" label=""/></td>
            </tr>
            <tr>
                <td>Trainer Name:</td><td classes={classes.cell30per}><TextInput source="trainer2" label=""/></td>
                <td>&nbsp;Initial:</td><td classes={classes.cell30per}><TextInput source="trainer2_init" label=""/></td>
            </tr>
            <tr>
                <td>Trainer Name:</td><td classes={classes.cell30per}><TextInput source="trainer3" label=""/></td>
                <td>&nbsp;Initial:</td><td classes={classes.cell30per}><TextInput source="trainer3_init" label=""/></td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            
            <tr>
                <td colSpan="4">
                    <table border="1" cellSpacing="0" style={{ width:"100%"}}>
                        <tbody>
                            <tr>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"25%", textAlign: "center"}}>Procedure</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"35%", textAlign: "center"}}>Reference</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"12%", textAlign: "center"}}>Date Introduce</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"8%", textAlign: "center"}}>Trainer Initial</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"8%", textAlign: "center"}}>Trainee Initial</th>
                                <th style={{backgroundColor: "silver", fontWeight: "bold", width:"12%", textAlign: "center"}}>Date Proficient</th>
                            </tr>
                            <FormDataConsumer>
                                    {
                                        ({ formData, ...rest }) =>
                                        <EditDetails  data={formData} ftype="content1" />
                                    }
                            </FormDataConsumer>
                            <tr>
                                <td colSpan="6" style={{backgroundColor: "silver", fontWeight: "bold", textAlign: "center"}}>
                                <FormDataConsumer>
                                    {
                                        ({ formData, ...rest }) => <Heading  data={formData.sub_heading}/>  
                                    }
                                </FormDataConsumer>
                                </td>
                            </tr>
                            <FormDataConsumer>
                                    {
                                        ({ formData, ...rest }) =>
                                            <EditDetails  data={formData} ftype="content2"/>
                                    }
                            </FormDataConsumer>
                        </tbody>
                    </table>
            
                </td>
            </tr>
            <tr><td  colSpan="4">&nbsp;</td></tr>
            <tr>
                <td  colSpan="4">
                
                </td>
            </tr>
            
            <tr>
                <td>Trainee Signature:</td><td classes={classes.cell30per}><TextInput source="trainee_sign" label=""/></td>
                <td>&nbsp;Date:</td><td classes={classes.cell30per}><DateInput source='trainee_sign_date'    label="" locales="en-us"  locales="en-us"/></td>
            </tr>
            <tr>
                <td>Center Manager Signature:</td><td classes={classes.cell30per}><TextInput source="mgr_sign" label=""/></td>
                <td>&nbsp;Date:</td><td classes={classes.cell30per}><DateInput source='mgr_sign_date'    label="" locales="en-us"  locales="en-us"/></td>
            </tr>
            <tr>
                <td>Quality Assurance Signature:</td><td classes={classes.cell30per}><TextInput source="qa_sign" label=""/></td>
                <td>&nbsp;Date:</td><td classes={classes.cell30per}><DateInput source='qa_sign_date'    label="" locales="en-us"  locales="en-us"/></td>
            </tr>
            <tr>
                <td colSpan="4">
                <FormDataConsumer>
                {
                    ({ formData, ...rest }) => <GetForm  data={formData}/>  
                }
                </FormDataConsumer>
                </td>
            </tr>
            </tbody>
        </table>
    </SimpleForm>
</Edit>
);

export default withStyles(editStyles)(CheckListEdit);